import type * as angular from 'angular';
import type LoggerService from '@app/service/logger.service';

export default function initializeRouteLogging(app: angular.IModule) {
  app.run([
    '$rootScope',
    'loggerService',
    ($rootScope: angular.IRootScopeService, loggerService: LoggerService) => {
      $rootScope.$on('$routeChangeStart', (event, next, current) => {
        loggerService.info('Route Change', {
          from: current?.originalPath,
          to: next?.originalPath
        });
      });
    }
  ]);
}
